"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumDomainsManager = void 0;
const axios_1 = __importDefault(require("axios"));
const typedi_1 = require("typedi");
const lit_html_1 = require("lit-html");
axios_1.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const dom_1 = require("@common/utils/dom");
const loader_1 = require("@common/loader/loader");
const simple_1 = require("@domain/templates/simple");
const translation_1 = require("@translation/services/translation");
const filters_1 = require("./filters");
/**
 * Менеджер списка премиальных доменов
 */
let PremiumDomainsManager = class PremiumDomainsManager {
    /**
     * Конструктор
     */
    constructor() {
        /**
         * Загрузка
         */
        this.loading = false;
        /**
         * Домены
         */
        this.domains = [];
        /**
         * Подгруженные домены
         */
        this.domainsLoaded = [];
        /**
         * Ошибка
         */
        this.error = false;
        /**
         * Конец списка
         */
        this.end = false;
        this.domainsFilter = typedi_1.Container.get(filters_1.PremiumSearchFilter);
        this.translations = typedi_1.Container.get(translation_1.TranslationService);
    }
    /**
     * Инициализирует состояние
     */
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loader = new loader_1.Loader('.js-loader', this.translations);
            yield this.loadDomains();
            this.registerScrollHandler();
        });
    }
    /**
     * Загружает домены
     */
    loadDomains() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loader.show();
            this.loading = true;
            this.error = false;
            try {
                const domains = yield this.getDomains(this.domainsFilter);
                this.domainsLoaded = domains;
                this.domains = [...this.domains, ...domains];
                this.end = !domains.length;
                yield this.appendDomains(this.domains);
            }
            catch (err) {
                this.renderError(err.message || this.translations.instant('somethingWentWrong'));
                this.error = true;
            }
            finally {
                this.loader.hide();
                this.loading = false;
            }
        });
    }
    /**
     * Возвращает домены
     */
    getDomains(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield axios_1.default.get(`/${this.translations.getLanguagePrefix()}/api/v1/domain/premium`, {
                    params: filter.toApi(),
                });
                return data.items;
            }
            catch (err) {
                const { data } = err.response;
                throw new Error(data && data.error || '');
            }
        });
    }
    /**
     * Добавляет домены в список
     */
    appendDomains(domains) {
        return __awaiter(this, void 0, void 0, function* () {
            this.renderPremiumDomains(domains);
        });
    }
    /**
     * Регистрирует обработчик скролла для подгрузки доменов
     */
    registerScrollHandler() {
        const paginator = document.querySelector('.js-search-more-results');
        if (!paginator || this.domainsLoaded.length <= 0) {
            return;
        }
        const button = paginator.querySelector('button');
        if (button) {
            button.style.display = 'block';
            button.addEventListener('click', () => {
                if (!this.loading && !this.error && (0, dom_1.inViewpoint)(paginator)) {
                    button.style.display = 'none';
                    this.domainsFilter.increaseOffset();
                    this.loadDomains().then(() => { button.style.display = 'block'; });
                }
            });
        }
    }
    /**
     * Генерирует представление доменов категории
     */
    renderPremiumDomains(domains) {
        const container = document.querySelector('.js-category-result-list');
        const searchOptions = document.querySelector('.search-options .option-list');
        const btnShowMore = document.querySelector('.js-search-more-results .js-search-more');
        if (!container) {
            return;
        }
        const params = window.location.search;
        if (!domains.length) {
            if (!params) {
                if (searchOptions)
                    searchOptions.classList.add('hidden');
            }
            else {
                if (searchOptions)
                    searchOptions.classList.remove('hidden');
            }
            if (btnShowMore)
                btnShowMore.setAttribute('style', 'display:none');
            return;
        }
        if (btnShowMore)
            btnShowMore.setAttribute('style', 'display:block');
        if (searchOptions)
            searchOptions.classList.remove('hidden');
        const templates = [];
        for (let i = 0; i < domains.length; i++) {
            templates.push((0, simple_1.getSimpleDomainTemplate)(domains[i], this.translations));
        }
        (0, lit_html_1.render)((0, lit_html_1.html) `${templates}`, container);
        const a = document.querySelector('.js-category-result-list');
    }
    /**
     * Генерирует представление ошибки
     */
    renderError(error) {
        const container = document.querySelector('.js-error-message');
        if (!container) {
            return;
        }
        (0, lit_html_1.render)((0, lit_html_1.html) `
            <div class="search-api-error">${error}</div>
        `, container);
    }
};
PremiumDomainsManager = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], PremiumDomainsManager);
exports.PremiumDomainsManager = PremiumDomainsManager;
